export const emailPattern =
  "^\\w+([-+\\.']\\w+)*@\\w+([-\\.]\\w+)*\\.\\w+([-\\.]\\w+)*$";

export const alphaNumPattern =
  /^[\p{L}\p{M}\p{N} ][\p{L}\p{M}\p{N} _'-]*[\p{L}\p{M}\p{N} ]$/u;

export const intergerNumPattern = '^[0-9]*$';

export const allowedLicensePlateSymbols = 'a-zA-Z\u0370-\u03FF0-9';
export const allowedDatePattern =
  '^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$';

export const licensePlatePatterns = {
  br: [
    {
      name: 'after1990Br',
      pattern: '^[a-zA-Z]{3}[0-9]{4}$',
      mask: 'UUU-0000',
    }, // ABC-1234
    {
      name: 'after2018Br',
      pattern: '^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$',
      mask: 'UUU0U00',
    }, // ABC1D23
  ],
  ee: [
    {
      name: 'after1998Ee',
      pattern: '^[0-9]{2,3}[a-zA-Z]{3}$',
      mask: '009 UUU',
    }, // 000 AAA
  ],
  es: [
    {
      name: 'actualEs',
      pattern:
        '^([a-zA-Z]{1,3}?[ ]?[-]?d{4}?[ ]?[-]?[a-zA-Z]{1,3}$|^[0-9]{4}?[ ]?[-]?[a-zA-Z]{3}$|^[a-zA-Z]{1,3}?[ ]?[-]?[0-9]{1,6}$|^[a-zA-Z]{1,2}?[ ]?[-]?[0-9]{1,3}?[ ]?[-]?[0-9]{1,3}$|^[a-zA-Z]{1,3}?[ ]?[-]?[0-9]{1,4}?[ ]?[-]?[a-zA-Z]{1,3}$|^[a-zA-Z]{2,3}?[ ]?[-]?[0-9]{1,6}?[ ]?[-]?[a-zA-Z]{1,2}$|^[a-zA-Z]{4}?[ ]?[-]?[0-9]{4}|^[a-zA-Z]{1}?[ ]?[-]?[0-9]{5,6}?[ ]?[-]?[a-zA-Z]{2}|)$',
      mask: 'aaaaaaaaaa',
    },
  ],
  fi: [
    {
      name: 'after1989Fi',
      pattern: '^[a-zA-Z]{2,3}[0-9]{1,3}$',
      mask: 'UUu-099',
    }, // AAA-000
  ],
  fr: [
    {
      name: 'after1950Fr',
      pattern: '^[0-9]{1,4}[a-zA-Z]{1,3}([0-9]{2}$|97[0-9]{1}$|2{1}[aAbB]{1}$)',
      mask: '0999-Uuu-0Aa',
    }, // FNI - 0000 AA 00 / 000 AAA 2A
    {
      name: 'after2009Fr',
      pattern: '^([a-zA-Z]{2}|[wW]{1})[0-9]{3}[a-zA-Z]{2}$',
      mask: 'Uu-000-UU',
    }, // SIV - AA-000-AA / W-000-AA
  ],
  gr: [
    {
      name: 'after1983Gr',
      pattern: '^[a-zA-Z\u0370-\u03FF]{3}[0-9]{4}$',
      mask: 'UUU-0000',
    }, // AAA-0000
  ],
  hu: [
    {
      name: 'actualHuFourLetters',
      pattern: '^[a-zA-Z]{4}[0-9]{3}$',
      mask: 'UUUU-000',
    }, // AAAA-123 / AAAA123
    {
      name: 'actualHuThreeLetters',
      pattern: '^[a-zA-Z]{3}[0-9]{3}$',
      mask: 'UUU-000',
    }, // AAA-123 / AAA123
  ],
  it: [
    {
      name: 'after1993It',
      pattern: '^[a-zA-Z0-9]{6,8}$',
      mask: 'AAAAAAaa',
    }, // AA 000AA
  ],
  lt: [
    {
      name: 'actualLt',
      pattern: '^[a-zA-Z]{3}[0-9]{3}$',
      mask: 'UUU 000',
    }, // AAA 000
  ],
  no: [
    {
      name: 'actualNo',
      pattern: '^[a-zA-Z]{2}[0-9]{5}$',
      mask: 'UU 00000',
    }, // AA 00000
  ],
  pt: [
    {
      name: 'after2020pt',
      pattern: '^[a-zA-Z]{2}[0-9]{2}[a-zA-Z]{2}$',
      mask: 'UU-00-UU',
    }, // AA-00-AA
    {
      name: 'after2005pt',
      pattern: '^[0-9]{2}[a-zA-Z]{2}[0-9]{2}$',
      mask: '00-UU-00',
    }, // 00-AA-00
    {
      name: 'after1992pt',
      pattern: '^[0-9]{4}[a-zA-Z]{2}$',
      mask: '00-00-UU',
    }, // 00-00-AA
    {
      name: 'after1932pt',
      pattern: '^[a-zA-Z]{2}[0-9]{4}$',
      mask: 'UU-00-00',
    }, // AA-00-00
    {
      name: 'guardaNacionalRepublicana1',
      pattern: '^GNR[a-zA-Z]{1}[0-9]{2}$',
      mask: 'AAA U-00',
    }, // GNR A-00
    {
      name: 'guardaNacionalRepublicana2',
      pattern: '^GNR[a-zA-Z]{1}[0-9]{3}$',
      mask: 'AAA U-000',
    }, // GNR A-000
    {
      name: 'guardaNacionalRepublicana3',
      pattern: '^GNR[a-zA-Z]{1}[0-9]{4}$',
      mask: 'AAA U-0000',
    }, // GNR A-0000
    {
      name: 'diplomatic',
      pattern: '^[0-9]{3}[a-zA-Z]{2}[0-9]{3}$',
      mask: '000-UU000',
    }, // 000-AA000
    {
      name: 'exportation',
      pattern: '^[0-9]{5}[a-zA-Z]{1}$',
      mask: '00000-U',
    }, // 00000-A
    {
      name: 'motoAfter2006',
      pattern: '^[0-9]{2}[a-zA-Z]{2}[0-9]{2}$',
      mask: '00 UU-00',
    }, // 00 AA-00
    {
      name: 'motoBefore2006',
      pattern: '^[0-9]{1}[a-zA-Z]{3}[0-9]{4}$',
      mask: '0-UUU 00-00',
    }, // 0-AAA 00-00
  ],
  de: [
    {
      name: 'actualGe',
      pattern: '^[a-zA-Z]{2,5}[0-9]{1,4}$',
      mask: 'AAAAAAAAA',
    },
  ],
};

export const phonePatterns = {
  br: [
    {
      name: 'br',
      pattern: '^[1-9]{2}[9]?[0-9]{8}$',
      code: '+55',
      mask: '(00)900000000',
    }, // 12 9 0000-0000 ou 12 0000-0000
  ],
  ee: [
    {
      name: 'ee',
      pattern: '^[0-9]{1,15}$',
      code: '+372',
      mask: '999999999999999',
    }, // 6000000 ou 50000000
  ],
  es: [
    {
      name: 'es',
      pattern: '^(?!600000000|666666666)[67][0-9]{8}$',
      code: '+34',
      mask: '000000000',
    }, // 600 000 000
    {
      name: 'fr',
      pattern: '^0$',
      code: '+34',
      mask: '0',
    }, // 0
  ],
  fi: [
    {
      name: 'fi',
      pattern: '^([0][4][0-9]|[0][4][5][7]|[0][5][0]){1}[0-9]{7}$',
      code: '+358',
      mask: '00090000000',
    }, // 045 000 00 00, ou 0457 000 00 00, ou 050 000 00 00
  ],
  fr: [
    {
      name: 'fr-gua',
      pattern: '^\\+590[0-9]{9}$',
      code: '+590',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-guy',
      pattern: '^\\+594[0-9]{9}$',
      code: '+594',
      mask: 'K0000000000 0',
    }, // 00 00 00 00 00
    {
      name: 'fr-mar',
      pattern: '^\\+596[0-9]{9}$',
      code: '+596',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-may',
      pattern: '^\\+269[0-9]{9}$',
      code: '+269',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-nc',
      pattern: '^\\+687[0-9]{9}$',
      code: '+687',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-pol',
      pattern: '^\\+689[0-9]{9}$',
      code: '+689',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-reu',
      pattern: '^\\+262[0-9]{9}$',
      code: '+262',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-spm',
      pattern: '^\\+508[0-9]{9}$',
      code: '+508',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr-wf',
      pattern: '^\\+681[0-9]{9}$',
      code: '+681',
      mask: 'K000000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr',
      pattern: '^[0][0-9]{9}$',
      code: '+33',
      mask: '0000000000',
    }, // 00 00 00 00 00
    {
      name: 'fr',
      pattern: '^\\+33[0-9]{9}$',
      code: '+33',
      mask: 'RRR$0000000000',
    }, // 00 00 00 00 00
  ],
  gr: [
    {
      name: 'gr',
      pattern: '^6[0-9]{9}$',
      code: '+30',
      mask: '0000000000',
    }, // 000 000 0000
  ],

  hu: [
    {
      name: 'hu',
      pattern: '^[0][0-9]{9}$',
      code: '+36',
      mask: '0000000000',
    }, // 00 00 00 00 00
    {
      name: 'hu',
      pattern: '^\\+36[0-9]{9}$',
      code: '+36',
      mask: 'KKK 000 000 000',
    }, // +36 123 456 789
  ],
  it: [
    {
      name: 'it',
      pattern: '^[3][0-9]{8,9}$',
      code: '+39',
      mask: '0090000000',
    }, // 30 000 0000, ou 300 000 0000
  ],
  lt: [
    {
      name: 'lt',
      pattern: '^[0-9]{8,9}$',
      code: '+370',
      mask: '009000000',
    }, // 00 000 000, ou 000 000 000
  ],
  no: [
    {
      name: 'no',
      pattern: '^[0-9]{8,9}$',
      code: '+47',
      mask: '000900000',
    }, // 000 00 000, ou 000 000 000
  ],
  pt: [
    {
      name: 'pt',
      pattern: '^[2-9]{1}[0-9]{8}$',
      code: '+351',
      mask: '000000000',
    }, // 300 000 000
  ],
  de: [
    {
      name: 'de',
      pattern: '^\\+49([0-9]{10}|[0-9]{12,13})$',
      code: '+49',
      mask: '00000009000000099',
    }, // 0049 000 000000000 ou 0049 0000 000000000 ou 0049 000 0000000
  ],
};

export function getMatchingPhonePattern(
  phoneNumber: string,
  countryCode: string
) {
  return phonePatterns[countryCode]?.find((pattern) =>
    new RegExp(pattern.pattern).test(
      phoneNumber.replace(/[^a-zA-Z\u0370-\u03FF0-9\+]/g, '')
    )
  );
}
